import React, { useRef, useState, useEffect } from "react";
import { Box } from "@mui/material";
import { useLocation } from "react-router-dom";
import CompanyLogo from "../views/LogoB.png";
// import CompanyLogo from "../views/LogoW.png";
import { colors } from "../../theme/tokens";

const FloatingLogo = () => {
  const logoRef = useRef<HTMLDivElement>(null);
  const location = useLocation();
  const isTopPage = location.pathname === "/";
  const [isHeroLoaded, setIsHeroLoaded] = useState(false);

  // HeroSectionのロード完了を待ってから表示
  useEffect(() => {
    if (isTopPage) {
      const timer = setTimeout(() => setIsHeroLoaded(true), 1200);
      return () => clearTimeout(timer);
    } else {
      setIsHeroLoaded(true);
    }
  }, [isTopPage]);

  // ヘッダーナビ(ResponsiveAppBar)がロゴを表示するため、トップページの装飾用オーバーレイのみ担当する
  if (!isTopPage) return null;

  const width = "100%";
  const height = "100%";

  const modeStyle = {
    position: "absolute",
    top: "30%",
    left: "50%",
    transform: "translateX(-50%)",
    width: "40vw",
    minWidth: "200px",
    maxWidth: "400px",
    opacity: isHeroLoaded ? 1 : 0,
    transition: "opacity 800ms ease-out",
  };

  return (
    <Box
      ref={logoRef}
      component="a"
      href="/"
      sx={{
        ...modeStyle,
        "&:focus-visible": {
          outline: `2px solid ${colors.primary[500]}`,
          outlineOffset: "2px",
        },
      }}
      aria-label="TOP"
    >
      {/* <img
        src={CompanyLogo}
        alt="Lamact"
        width={width}
        height={height}
        style={{
          display: "block",
          filter: "drop-shadow(5px 5px 5px rgba(255, 255, 255, 0.9))",
          // "brightness(0) invert(1) drop-shadow(0 2px 2px rgba(255, 255, 255, 0.3))",
        }}
      /> */}
    </Box>
  );
};

export default FloatingLogo;
